import React from 'react';
import styled from 'styled-components';
import LicenseManagementImage from '../../../img/license-management.svg';

const Container = styled.div`
  width: 100%;
  height: 520px;
  border-radius: 10px;
  background-color: #f6f9ff;
`;

const TextContainer = styled.div`
  margin: 60px;

  div:nth-child(odd) {
    margin-bottom: 18px;
  }

  div:nth-child(2) {
    margin-bottom: 40px;
  }
`;

const EmphasizedText = styled.div`
  font-size: ${(props) => (props.size ? props.size : '18px')};
  font-weight: 600;
  line-height: 1;
  color: #101938;
`;

const MarketMessage = styled.div`
  font-family: 'Lato';
  font-size: 14px;
  line-height: 1.57;
  color: rgba(0, 0, 0, 0.85);
  white-space: pre-line;
`;

const ImageContainer = styled.div`
  margin: 40px;
  display: flex;
  justify-content: flex-end;
`;

export function LicenseUpgradeable() {
  return (
    <Container>
      <TextContainer>
        <EmphasizedText size="24px">License Management</EmphasizedText>
        <MarketMessage>
          {`Interested in learning more about our License Management solutions?
          Give us a call or send us an email to get in touch with our sales team.`}
        </MarketMessage>
        <EmphasizedText>Phone: (858) 333-7835</EmphasizedText>
        <EmphasizedText>Email: rentalscape@deckard.com</EmphasizedText>
      </TextContainer>

      <ImageContainer>
        <LicenseManagementImage />
      </ImageContainer>
    </Container>
  );
}
